<template>
<div>
    <img src="//cdn.edstatic.com/203012120000/ed8a4f193745e2bb936552f626c70a1f/2022/12/52273491-a159-46c5-b162-f7c554975538.jpg" @click="showBig=true">
    <van-image-preview v-model="showBig" :images="['//cdn.edstatic.com/203012120000/ed8a4f193745e2bb936552f626c70a1f/2022/12/52273491-a159-46c5-b162-f7c554975538.jpg']" :showIndex="false" maxZoom="10">
      </van-image-preview>
</div>
</template>

<script>
import {ButtonDetail} from '../../config/interface.js'
export default {
    data(){
        return {
            showBig:false
        }

    },
    created(){
        this.button_id=this.$route.query.button_id?this.$route.query.button_id:this.$route.query.b_id;
        this.getButtonData();
    },
    methods:{
        //获取按钮信息
        getButtonData(){
            if(this.button_id){
                const url=ButtonDetail;
                let params={
                    button_id:this.button_id
                }
                const method="POST";
                fetch(url,params,method)
                .then((res)=>{
                    if(res.code==0){
                        document.title=res.data.share_title;
                        if(common.is_weixin()){
                            let data=res.data;
                            common.wxShare(data.share_title,data.share_sub_title,data.share_img);
                        }
                    }
                })

            }
        },
    }
}
</script>

<style scoped>
h2{
    text-align: center;
    line-height: 30px;
    margin-top: 20px;
}
h3{
    text-align: center;
    line-height: 30px;
    margin-bottom: 10px;

}
img{
    width: 100%;
    display: block;
}
</style>


// WEBPACK FOOTER //
// src/pages/cec2022/schedulePoster.vue